import React, { memo, useMemo } from 'react';
import clsx from 'clsx';
import * as d3 from 'd3';
import { getCssVariable } from '../../../utils';

import './GradientBar.scss';

interface GradientBarProps {
  width?: string;
  height?: string;
  className?: string;
  style?: React.CSSProperties;
}

const GradientBar: React.FC<GradientBarProps> = memo(
  ({ width = '10px', height = '100%', className, style }) => {
    const colorPalette = [
      getCssVariable('--color-red-base'),
      getCssVariable('--color-yellow-base'),
      getCssVariable('--color-green-base'),
    ];

    const gradientId = useMemo(() => `gradient-${Math.random().toString(36).substr(2, 9)}`, []);

    const colorScale = useMemo(() => {
      return d3.scaleSequential().interpolator(d3.interpolateRgbBasis(colorPalette)).domain([0, 1]);
    }, [colorPalette]);

    // Generate gradient stops
    const gradientStops = useMemo(() => {
      const stops = [];
      for (let i = 0; i <= 100; i += 10) {
        const offset = `${i}%`;
        const color = colorScale(i / 100);
        stops.push(<stop key={i} offset={offset} stopColor={color} />);
      }
      return stops;
    }, [colorScale]);

    return (
      <div
        className={clsx('gradient-bar', className)}
        style={{
          width,
          height,
          ...style,
        }}
      >
        <svg width="100%" height="100%">
          <defs>
            <linearGradient id={gradientId} x1="0" x2="0" y1="1" y2="0">
              {gradientStops}
            </linearGradient>
          </defs>
          <rect width="100%" height="100%" fill={`url(#${gradientId})`} />
        </svg>
      </div>
    );
  }
);

export default GradientBar;
